module.exports = __webpack_public_path__ + "static/programma_eng-001bb67b81fc4aa3b89812503e6259ec.png";